const EMAIL_CAPTURE_STORAGE_KEY = 'founderDna_emailCaptures_v1';

const safeParseJson = (value) => {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch (e) {
    return null;
  }
};

export const getEmailCaptures = () => {
  const raw = localStorage.getItem(EMAIL_CAPTURE_STORAGE_KEY);
  const parsed = safeParseJson(raw);
  if (!Array.isArray(parsed)) return [];
  return parsed;
};

export const addEmailCapture = ({ email, context }) => {
  const history = getEmailCaptures();
  const entry = {
    email,
    context: context || {},
    createdAt: new Date().toISOString(),
  };

  const next = [entry, ...history].slice(0, 50);
  localStorage.setItem(EMAIL_CAPTURE_STORAGE_KEY, JSON.stringify(next));
  return entry;
};

